import { useEffect, useState } from "react";
import { Request } from "../../hooks/Request";
import { Anchor } from "../../components/Text";
import Select from "react-select";
import { useDialog } from "../../contexts/DialogContext";
import { validateArray } from "../../utils/validate";
import H3, { H3Custom } from "../../components/Text/H3";
import TableComplete from "../../components/Tables/TableComplete";
import { mapIcons } from "../../utils/constant";
import FormAddPaymentReq from "./FormAddPaymentReq";
import { Tooltip } from "react-tippy";
import { DialogConfirmation } from "../../components/Modal";
import { Badge } from "../../components/Badge/Badge";
import { useAuth } from "../../contexts/AuthContext";
import DialogPerformAccounting from "./DialogPerformAccounting";
import DialogDeleteAccounting from "./DialogDeleteAccounting";
// import { Button } from "../../components/Buttons";
// import FormVoucherPayment from "./FormVoucherPayment";

export const AddSubPaymentReqForm = ({
  item,
  reload,
  onClose,
  permissions,
  rol,
}) => {
  const { user } = useAuth();
  const { openDialog, dialogClose } = useDialog();

  // Estados
  const [selectValue, setSelectValue] = useState(null);
  const [tableTitleOpts, setTableTitleOpts] = useState([]);

  // Filtrado de permisos
  const permissionField = {
    ...permissions,
    fields: permissions.fields.filter((x) => x.rols.includes(rol)),
  };

  // Datos de la API
  const { data: fieldOpts1 } = Request({
    urlApi: `dropdown/documentos-para-solicitudes-de-importacion/options`,
  });

  const { data: fieldOpts2 } = Request({
    urlApi: `dropdown/documentos-para-solicitudes-de-exportacion/options`,
  });

  const { data, call } = Request({
    urlApi: `procElement/${item.id}/subElements`,
  });

  // Efectos
  useEffect(() => {
    if (data) {
      const uniqueLabels = [...new Set(data.map((item) => item.label))];
      setTableTitleOpts(uniqueLabels);
    }
  }, [data]);

  // Funciones auxiliares
  const generateFormAdd = (
    dataI,
    onClose,
    reload,
    fieldOpts,
    fieldlabel = null,
    type = null,
    selectedOption,
  ) => {
    const selectedOpt = selectedOption?.label ?? selectValue;

    const commonProps = {
      data: dataI,
      onClose,
      allowEmpty: true,
      reload,
      initVals: {
        ...dataI,
        mainProcElementId: item.id,
        label: dataI?.label ? dataI?.label : selectedOpt,
      },
      formFields: validateArray(permissionField?.fields)
        ? permissionField.fields.filter((x) => x.formConfig === true)
        : [],
      refFileIndex: permissionField?.openUrl,
      type: type ?? dataI.procedureTypeId,
    };

    return (
      <FormAddPaymentReq
        {...commonProps}
        addTitle={selectedOpt ? (selectedOpt ?? fieldlabel) : undefined}
        subElement={data.map((item) => {
          const addData = item?.details ? JSON.parse(item?.details) : {};
          return { ...addData, ...item };
        })}
        reload={() => {
          reload();
          setSelectValue("");
        }}
      />
    );
  };

  const handleForm = (data) => {
    const parsedDetails = data.details ? JSON.parse(data.details) : [];
    const formattedData = {
      ...data,
      ...parsedDetails,
    };
    openDialog(generateFormAdd(formattedData, dialogClose, call));
  };

  const handleCreateForm = (selectedOption, type) => {
    if (selectedOption) {
      openDialog(
        generateFormAdd(
          data,
          dialogClose,
          () => {
            call();
            reload();
          },
          type === 1 ? fieldOpts1 : fieldOpts2,
          null,
          type,
          selectedOption,
        ),
      );
    }
  };

  const handleDelete = (data) => {
    openDialog(
      <DialogConfirmation
        onClose={dialogClose}
        method="delete"
        url={`/procElement/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={() => {
          call();
          reload();
        }}
      >
        <H3>¿Estás seguro que quieres eliminar el archivo?</H3>
      </DialogConfirmation>,
    );
  };

  const handleStatusUpdate = (data) => {
    openDialog(
      <DialogConfirmation
        onClose={dialogClose}
        method="patch"
        url={`/procElement/${data.id}/changeStatus`}
        texBtn="Modificar"
        handleSuccess={() => {
          call();
          reload();
        }}
      >
        <H3>¿Estás seguro que quieres cambiar el estado?</H3>
      </DialogConfirmation>,
    );
  };

  function handlePerformAccounting(item) {
    openDialog(
      <DialogPerformAccounting
        item={item}
        onClose={dialogClose}
        handleSuccess={() => {
          call();
          reload();
        }}
      >
        <H3>¿Estás seguro que quieres contabilizar el pago?</H3>
      </DialogPerformAccounting>,
    );
  }

  function handleDeleteAccounting(item) {
    openDialog(
      <DialogDeleteAccounting
        item={item}
        onClose={dialogClose}
        handleSuccess={() => {
          call();
          reload();
        }}
      >
        <H3>¿Estás seguro que desea eliminar la contabilización?</H3>
        <p className="text-gray-600 mt-2">
          Se eliminarán los registros contables asociados. Revise los enlaces
          antes de proceder.
        </p>
      </DialogDeleteAccounting>,
    );
  }

  // Preparación de opciones para los Select
  const options1 =
    fieldOpts1?.map((opt) => ({
      value: opt.id,
      label: opt.name,
    })) || [];

  const options2 =
    fieldOpts2?.map((opt) => ({
      value: opt.id,
      label: opt.name,
    })) || [];

  const rolesIds = user?.rols?.map((rol) => rol.id) || [];

  // Configuración de columnas de la tabla
  const getTableColumns = () => {
    const baseColumns = [
      {
        name: "stringNumber",
        label: "Trámite",
        type: "text",
      },
      {
        name: "internCode",
        label: "Nro. interno",
        type: "text",
      },
    ];

    const permissionColumns = validateArray(permissionField?.fields)
      ? permissionField.fields
          .filter((x) => x.tableConfig === true)
          .map((tableItem) => {
            if (tableItem.type === "custom") {
              if (tableItem.name === permissionField?.openUrl) {
                return {
                  name: tableItem.name,
                  label: "Enlace",
                  type: "custom",
                  builder: (item) =>
                    item ? (
                      <Anchor
                        href={item}
                        className="text-[#1d4ed8] underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Abrir
                      </Anchor>
                    ) : (
                      "-"
                    ),
                };
              } else {
                return {
                  name: tableItem.name,
                  label: tableItem.label,
                  type: "custom",
                  builder: (item) => (
                    <div className="flex">
                      <Badge
                        data={item === true ? "approved" : "pending"}
                        className="text-xs px-2 py-1"
                      />
                    </div>
                  ),
                };
              }
            }
            return tableItem;
          })
      : [];

    const actionColumn = {
      name: "add",
      type: "action",
      label: "Opciones",
      sticky: true,
      actions: [
        {
          label: "Editar",
          icon: "fas fa-edit",
          action: handleForm,
          color: "text-[#1d4ed8]",
        },
        ...(permissionField?.changeStatus?.includes(rol)
          ? [
              {
                icon: "fas fa-trash",
                builder: (item) =>
                  item ? (
                    <div
                      className="text-xl cursor-pointer"
                      onClick={() => handleStatusUpdate(item)}
                    >
                      <Tooltip
                        title="Cambiar estado"
                        position="right"
                        trigger="mouseenter"
                      >
                        {mapIcons(item.check ? "approved" : "pending")}
                      </Tooltip>
                    </div>
                  ) : (
                    "-"
                  ),
              },
            ]
          : []),
        // ...(rolesIds.includes(11)
        //   ? [
        //       {
        //         icon: "fas fa-calculator",
        //         builder: (item) => (
        //           <button
        //             onClick={
        //               item.voucherId
        //                 ? () => handleDeleteAccounting(item)
        //                 : () => handlePerformAccounting(item)
        //             }
        //             disabled={rol !== "cont"}
        //             className={`text-md text-gray-100 w-6 h-6 rounded-full ${
        //               item.voucherItemId
        //                 ? "bg-purple-500"
        //                 : item.voucherId
        //                   ? "bg-green-500 hover:bg-red-500"
        //                   : rol === "cont"
        //                     ? "bg-gray-500"
        //                     : "bg-gray-200"
        //             }`}
        //           >
        //             <Tooltip
        //               title={
        //                 rol === "cont"
        //                   ? "Contabilizar"
        //                   : "Debes tener el rol para contabilizar"
        //               }
        //               position="right"
        //               trigger="mouseenter"
        //             >
        //               <i className="fas fa-calculator"></i>
        //             </Tooltip>
        //           </button>
        //         ),
        //       },
        //     ]
        //   : []),
        ...(permissionField?.openUrl
          ? [
              {
                icon: "fas fa-trash",
                builder: (item) =>
                  item ? (
                    <Tooltip
                      title="Abrir"
                      position="right"
                      trigger="mouseenter"
                    >
                      <Anchor
                        href={item[permissionField.openUrl]}
                        className={`${
                          item[permissionField.openUrl]
                            ? "text-[#1d4ed8]"
                            : "text-gray-400"
                        } text-lg`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="far fa-file-pdf" />
                      </Anchor>
                    </Tooltip>
                  ) : (
                    "-"
                  ),
              },
            ]
          : []),
        {
          label: "Eliminar",
          icon: "fas fa-trash",
          action: handleDelete,
          color: "text-red-500",
        },
      ].filter(Boolean),
    };

    return [...baseColumns, ...permissionColumns, actionColumn];
  };

  // Procesar datos para la tabla
  // const processTableData = () => {
  //   if (!data) return [];
  //   return data.map((datai) => {
  //     const parsedDetails = datai.details
  //       ? typeof datai.details === "string"
  //         ? JSON.parse(datai.details)
  //         : datai.details
  //       : [];

  //     return {
  //       ...datai,
  //       ...parsedDetails,
  //       procedureTypeId: datai.procedureTypeId
  //         ? datai.procedureTypeId
  //         : item.procedureTypeId,
  //       procedureId: datai.procedureId ? datai.procedureId : item.procedureId,
  //       stringNumber:
  //         datai.stringNumber && datai.stringNumber !== "E/"
  //           ? datai.stringNumber
  //           : item.stringNumber,
  //     };
  //   });
  // };

  // function handleVoucher() {
  //   openDialog(
  //     <FormVoucherPayment
  //       payment={item}
  //       subElement={data.map((item) => {
  //         const addData = item?.details ? JSON.parse(item?.details) : {};
  //         return { ...addData, ...item };
  //       })}
  //       onClose={dialogClose}
  //       openDialog={openDialog}
  //       handleSuccess={() => {
  //         call();
  //         reload();
  //       }}
  //       voucherToEdit={item.voucherId}
  //     />,
  //   );
  // }

  const processTableData = () => {
    if (!data) return {};

    // Agrupar datos por label
    const groupedData = {};

    data.forEach((datai) => {
      const parsedDetails = datai.details
        ? typeof datai.details === "string"
          ? JSON.parse(datai.details)
          : datai.details
        : [];

      const processedItem = {
        ...datai,
        ...parsedDetails,
        procedureTypeId: datai.procedureTypeId
          ? datai.procedureTypeId
          : item.procedureTypeId,
        procedureId: datai.procedureId ? datai.procedureId : item.procedureId,
        stringNumber:
          datai.stringNumber && datai.stringNumber !== "E/"
            ? datai.stringNumber
            : item.stringNumber,
      };

      const label = datai.label || "Sin categoría";

      if (!groupedData[label]) {
        groupedData[label] = [];
      }

      groupedData[label].push(processedItem);
    });

    return groupedData;
  };

  // Función para renderizar tablas por grupo
  const renderTablesByGroup = () => {
    const groupedData = processTableData();
    const groupKeys = Object.keys(groupedData);

    if (groupKeys.length === 0) {
      return (
        <div className="text-center py-4 text-gray-500">
          No hay documentos para mostrar
        </div>
      );
    }

    return groupKeys.map((groupLabel) => (
      <div
        key={groupLabel}
        className="bg-stone-400/20 shadow-sm shadow-stone-400 p-4 rounded-md mb-4"
      >
        <H3Custom className="text-start mb-1 text-sm font-semibold">
          {groupLabel}
        </H3Custom>
        <TableComplete
          header={getTableColumns()}
          data={groupedData[groupLabel]}
        />
      </div>
    ));
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <span className="my-[10px] font-bold text-lg">
          SOLICITUD NRO <span className="text-red-500">{item.num}</span>
        </span>
        {/* <Button onClick={handleVoucher}>
          <i className="fas fa-tasks"></i>
        </Button> */}
      </div>

      {/* Selectores de documentos */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 bg-stone-400/20 p-2 rounded-md">
        <div>
          <label className="text-sm font-semibold" htmlFor="list1">
            Importación
          </label>
          <Select
            id="list1"
            name="FieldId"
            value={options1.find((opt) => opt.value === selectValue) || null}
            onChange={(selectedOption) => {
              setSelectValue(selectedOption?.value || "");
              handleCreateForm(selectedOption, 1);
            }}
            options={options1}
            placeholder="Seleccionar documento"
            isClearable
          />
        </div>

        <div>
          <label className="text-sm font-semibold" htmlFor="list2">
            Exportación
          </label>
          <Select
            id="list2"
            name="FieldId"
            value={options2.find((opt) => opt.value === selectValue) || null}
            onChange={(selectedOption) => {
              setSelectValue(selectedOption?.value || "");
              handleCreateForm(selectedOption, 2);
            }}
            options={options2}
            placeholder="Seleccionar documento"
            isClearable
          />
        </div>
      </div>

      <div className="overflow-auto flex flex-col gap-3 pt-4">
        {renderTablesByGroup()}
      </div>
    </div>
  );
};
